/**
 * Data e hora de um evento de auditoria com o fuso identificável (ex.: "26/10/2026 12:30:05 GMT-3").
 * O backend grava em UTC; se vier sem indicação de fuso (registros antigos), é tratado como UTC — nunca como horário
 * local, que mostraria a hora errada.
 */
export const formatarDataHoraComFuso = (iso?: string | null, fusoHorario?: string): string => {
  if (!iso) return '—';
  const temFuso = /([zZ]|[+-]\d{2}:?\d{2})$/.test(iso);
  const data = new Date(temFuso ? iso : `${iso}Z`);
  if (Number.isNaN(data.getTime())) return '—';
  return data.toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit', timeZoneName: 'short', ...(fusoHorario ? { timeZone: fusoHorario } : {}) });
};
